export const comments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=simple%20warm%20tone%20portrait%20avatar%20circle%20abstract%20minimal%20style%20with%20soft%20amber%20lighting%2C%20clean%20composition%2C%20no%20face%20details%2C%20artistic%20minimal&width=80&height=80&seq=avatar-c01&orientation=squarish',
    author: '光影追梦人',
    date: '2026-07-28',
    rating: 5,
    content: '画质真的没话说，蓝光播放效果太震撼了！界面也很清爽，找片超方便，最近在这里重温了好多经典老片，每一帧都是视觉享受。',
    tag: '画质控',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=simple%20warm%20tone%20portrait%20avatar%20circle%20abstract%20minimal%20style%20with%20soft%20coral%20lighting%2C%20clean%20composition%2C%20no%20face%20details%2C%20artistic%20minimal&width=80&height=80&seq=avatar-c02&orientation=squarish',
    author: '电影控',
    date: '2026-07-26',
    rating: 5,
    content: '资源更新速度很快，新片上线基本同步，而且完全免费，良心平台！片库也很全，从国产到海外大片应有尽有。',
    tag: '老用户',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=simple%20warm%20tone%20portrait%20avatar%20circle%20abstract%20minimal%20style%20with%20soft%20rose%20lighting%2C%20clean%20composition%2C%20no%20face%20details%2C%20artistic%20minimal&width=80&height=80&seq=avatar-c03&orientation=squarish',
    author: '周末影迷',
    date: '2026-07-25',
    rating: 5,
    content: '用了半年多了，高清画质很稳定，分类也很清晰。关键是不用注册就能直接看，体验特别好，推荐给身边好多朋友了。',
    tag: '忠实观众',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=simple%20warm%20tone%20portrait%20avatar%20circle%20abstract%20minimal%20style%20with%20soft%20golden%20lighting%2C%20clean%20composition%2C%20no%20face%20details%2C%20artistic%20minimal&width=80&height=80&seq=avatar-c04&orientation=squarish',
    author: '深夜放映室',
    date: '2026-07-23',
    rating: 4,
    content: '超清画质看老片真的太享受了，很多经典影片在这里都能找到。加载速度也快，晚上窝在沙发里看一部好电影，就是最好的放松。',
    tag: '电影爱好者',
  },
];

export const rankings = [
  {
    rank: 1,
    title: '时空旅人',
    category: '科幻 / 冒险',
    heat: '9.8',
    image: 'https://readdy.ai/api/search-image?query=modern%20sci-fi%20movie%20poster%20aesthetic%20with%20warm%20golden%20cinematic%20lighting%2C%20abstract%20cosmic%20elements%2C%20deep%20space%20with%20amber%20nebula%20tones%2C%20clean%20minimal%20poster%20style%2C%20professional%20movie%20art%2C%20no%20text&width=400&height=560&seq=rank-r01&orientation=portrait',
  },
  {
    rank: 2,
    title: '山河故人',
    category: '剧情 / 文艺',
    heat: '9.6',
    image: 'https://readdy.ai/api/search-image?query=artistic%20drama%20movie%20poster%20with%20warm%20nostalgic%20atmosphere%2C%20soft%20mountain%20landscape%20silhouette%2C%20golden%20hour%20lighting%2C%20elegant%20composition%2C%20clean%20poster%20aesthetic%2C%20poetic%20cinema%20style%2C%20no%20text&width=400&height=560&seq=rank-r02&orientation=portrait',
  },
  {
    rank: 3,
    title: '暗夜追踪',
    category: '动作 / 悬疑',
    heat: '9.4',
    image: 'https://readdy.ai/api/search-image?query=noir%20action%20thriller%20movie%20poster%20with%20warm%20dark%20tones%2C%20dramatic%20shadow%20play%2C%20urban%20night%20aesthetic%2C%20amber%20streetlight%20glow%2C%20clean%20cinematic%20poster%20style%2C%20mysterious%20atmosphere%2C%20no%20text&width=400&height=560&seq=rank-r03&orientation=portrait',
  },
  {
    rank: 4,
    title: '深海传说',
    category: '动画 / 奇幻',
    heat: '9.3',
    image: 'https://readdy.ai/api/search-image?query=animated%20fantasy%20movie%20poster%20with%20warm%20underwater%20light%20rays%2C%20mystical%20ocean%20atmosphere%2C%20golden%20sunbeams%20through%20water%2C%20enchanting%20composition%2C%20clean%20poster%20aesthetic%2C%20magical%20tone%2C%20no%20text&width=400&height=560&seq=rank-r04&orientation=portrait',
  },
  {
    rank: 5,
    title: '城市之光',
    category: '喜剧 / 爱情',
    heat: '9.1',
    image: 'https://readdy.ai/api/search-image?query=romantic%20comedy%20movie%20poster%20with%20warm%20city%20twilight%20atmosphere%2C%20soft%20golden%20sunset%20skyline%2C%20cozy%20urban%20vibe%2C%20elegant%20clean%20poster%20style%2C%20heartwarming%20composition%2C%20no%20text&width=400&height=560&seq=rank-r05&orientation=portrait',
  },
  {
    rank: 6,
    title: '荒野传奇',
    category: '冒险 / 纪录',
    heat: '8.9',
    image: 'https://readdy.ai/api/search-image?query=adventure%20documentary%20movie%20poster%20with%20warm%20desert%20landscape%2C%20golden%20sand%20dunes%20at%20sunset%2C%20vast%20horizon%2C%20epic%20cinematic%20composition%2C%20clean%20poster%20style%2C%20natural%20grandeur%2C%20no%20text&width=400&height=560&seq=rank-r06&orientation=portrait',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '暑期档必看 · 五部高口碑新片盘点',
    description: '从动作大片到文艺佳作，这个夏天不可错过的观影清单，每一部都值得细细品味。',
    image: 'https://readdy.ai/api/search-image?query=warm%20summer%20cinema%20atmosphere%20with%20golden%20sunlight%20through%20theater%20window%2C%20cozy%20movie%20watching%20vibe%2C%20soft%20amber%20and%20cream%20tones%2C%20artistic%20composition%2C%20cinematic%20aesthetic%2C%20no%20people%20no%20text&width=800&height=500&seq=caro-c01&orientation=landscape',
    tag: '编辑精选',
    date: '2026-07-30',
  },
  {
    id: 2,
    title: '经典重映 · 那些年我们追过的港片',
    description: '重温黄金时代的香港电影，从武侠到警匪，每一帧都是难以复制的光影记忆。',
    image: 'https://readdy.ai/api/search-image?query=nineties%20Hong%20Kong%20cinema%20nostalgic%20aesthetic%20with%20warm%20neon%20glow%2C%20vintage%20movie%20theater%20atmosphere%2C%20golden%20amber%20lighting%2C%20retro%20cinematic%20composition%2C%20no%20people%20no%20text&width=800&height=500&seq=caro-c02&orientation=landscape',
    tag: '怀旧专场',
    date: '2026-07-28',
  },
  {
    id: 3,
    title: '科幻迷集结 · 年度最受期待的科幻巨制',
    description: '从太空探索到人工智能，科幻电影正在重新定义视觉叙事的边界。',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20cinema%20visual%20with%20warm%20cosmic%20glow%2C%20abstract%20geometric%20space%20elements%2C%20amber%20and%20deep%20coral%20nebula%2C%20clean%20cinematic%20aesthetic%2C%20no%20people%20no%20text&width=800&height=500&seq=caro-c03&orientation=landscape',
    tag: '科幻专题',
    date: '2026-07-25',
  },
  {
    id: 4,
    title: '新人导演崛起 · 不可忽视的华语新力量',
    description: '一批才华横溢的新导演正在改写华语电影的格局，他们的作品值得被更多人看到。',
    image: 'https://readdy.ai/api/search-image?query=independent%20cinema%20atmosphere%20with%20warm%20spotlight%20on%20empty%20stage%2C%20artistic%20film%20production%20vibe%2C%20golden%20amber%20lighting%2C%20clean%20composition%2C%20cinematic%20aesthetic%2C%20no%20people%20no%20text&width=800&height=500&seq=caro-c04&orientation=landscape',
    tag: '新锐推荐',
    date: '2026-07-22',
  },
  {
    id: 5,
    title: '纪录片精选 · 用镜头记录真实世界',
    description: '精选年度高分纪录片，从自然奇观到社会观察，用真实的影像力量打动你。',
    image: 'https://readdy.ai/api/search-image?query=documentary%20cinematography%20aesthetic%20with%20warm%20natural%20light%20through%20leaves%2C%20organic%20textures%2C%20golden%20hour%20glow%2C%20clean%20cinematic%20composition%2C%20nature%20inspired%20tone%2C%20no%20people%20no%20text&width=800&height=500&seq=caro-c05&orientation=landscape',
    tag: '纪录精选',
    date: '2026-07-20',
  },
  {
    id: 6,
    title: '动画世界 · 不止是给孩子的礼物',
    description: '从东方美学到西方奇幻，动画电影的边界在不断扩展，成年人也能找到共鸣。',
    image: 'https://readdy.ai/api/search-image?query=artistic%20animation%20studio%20atmosphere%20with%20warm%20soft%20lighting%2C%20creative%20workspace%20vibe%2C%20colorful%20but%20muted%20palette%2C%20golden%20amber%20accents%2C%20clean%20composition%2C%20no%20people%20no%20text&width=800&height=500&seq=caro-c06&orientation=landscape',
    tag: '动画专场',
    date: '2026-07-18',
  },
];

export const updates = [
  {
    id: 1,
    date: '07-31',
    title: '《时空旅人》4K修复版独家上线',
    description: '科幻经典以全新画质回归，新增幕后花絮和导演评论音轨',
    tag: '新片上线',
  },
  {
    id: 2,
    date: '07-30',
    title: '暑期观影季活动正式开启',
    description: '每日推荐一部高分佳作，评论区分享观后感有机会获得限量周边',
    tag: '活动',
  },
  {
    id: 3,
    date: '07-29',
    title: '播放器全面升级至蓝光引擎',
    description: '画质提升30%，加载速度优化，支持更多设备无缝切换观看',
    tag: '技术',
  },
  {
    id: 4,
    date: '07-27',
    title: '新增「导演专题」分类板块',
    description: '按导演作品时间线整理片单，方便影迷系统性地了解导演风格演变',
    tag: '功能',
  },
  {
    id: 5,
    date: '07-25',
    title: '《暗夜追踪》续集定档预告发布',
    description: '原班人马回归，动作场面全面升级，定档今年贺岁档',
    tag: '预告',
  },
  {
    id: 6,
    date: '07-23',
    title: '与三大片方达成内容合作协议',
    description: '片库新增超过500部正版高清影片，涵盖近十年热门院线作品',
    tag: '合作',
  },
  {
    id: 7,
    date: '07-21',
    title: '手机端观影体验优化完成',
    description: '移动端界面全新改版，支持手势控制亮度音量，横竖屏无缝切换',
    tag: '优化',
  },
  {
    id: 8,
    date: '07-19',
    title: '「经典港片回顾」专题正式上线',
    description: '收录80-00年代百部经典香港电影，按年代和类型双重索引',
    tag: '专题',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '时空旅人 · 终极预告',
    duration: '02:35',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20scene%20with%20warm%20cosmic%20lighting%2C%20dramatic%20composition%2C%20golden%20amber%20tones%2C%20deep%20space%20aesthetic%2C%20professional%20film%20still%20style%2C%20no%20text%20overlay&width=800&height=450&seq=media-m01&orientation=landscape',
    tag: '预告片',
  },
  {
    id: 2,
    title: '山河故人 · 幕后纪录',
    duration: '08:12',
    views: '56万',
    image: 'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20film%20production%20with%20warm%20natural%20lighting%2C%20movie%20set%20atmosphere%2C%20golden%20hour%20glow%2C%20cinematic%20documentary%20style%2C%20organic%20composition%2C%20no%20people%20no%20text&width=800&height=450&seq=media-m02&orientation=landscape',
    tag: '幕后',
  },
  {
    id: 3,
    title: '深海传说 · 视觉解析',
    duration: '05:48',
    views: '92万',
    image: 'https://readdy.ai/api/search-image?query=animated%20film%20visual%20development%20art%20with%20warm%20underwater%20lighting%2C%20magical%20ocean%20atmosphere%2C%20golden%20sunbeams%2C%20artistic%20concept%20art%20style%2C%20clean%20composition%2C%20no%20text&width=800&height=450&seq=media-m03&orientation=landscape',
    tag: '解析',
  },
];

export const faqs = [
  {
    id: 1,
    question: '6080新视觉影视需要注册才能观看吗？',
    answer: '不需要。我们始终坚持免费免注册的观影体验，打开网站即可直接搜索和观看所有影片，无需任何账号绑定或手机验证。',
  },
  {
    id: 2,
    question: '支持哪些画质选择？最高能到什么清晰度？',
    answer: '平台提供流畅、高清、超清和蓝光四种画质选项。蓝光画质支持1080P全高清播放，部分热门影片更支持4K超高清，可根据网络状况自由切换。',
  },
  {
    id: 3,
    question: '影片资源多久更新一次？新片上线速度快吗？',
    answer: '片库每日动态更新，热门院线影片下映后最快一周内上线。持续追踪全球影视动态，确保观众第一时间看到想看的作品。',
  },
  {
    id: 4,
    question: '支持哪些设备观看？手机和平板能看吗？',
    answer: '全面支持电脑、平板和手机端观看。网页采用响应式设计，自动适配不同屏幕尺寸。手机端更支持手势控制亮度和音量，横竖屏自由切换。',
  },
  {
    id: 5,
    question: '为什么有些影片加载比较慢？',
    answer: '加载速度与您的网络环境和当前画质选择有关。建议在网络稳定时选择蓝光画质，网络波动时可切换至高清模式。我们持续优化CDN分发，大部分地区可流畅播放。',
  },
  {
    id: 6,
    question: '影片有广告吗？观影体验如何？',
    answer: '我们承诺纯净观影体验，影片播放过程中不插入任何广告。极简界面设计让你专注于电影本身，享受沉浸式的高清视觉盛宴。',
  },
];

export const features = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '蓝光超清画质',
    description: '支持1080P蓝光和4K超高清播放，每一帧都纤毫毕现，带来影院级的视觉体验。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速加载播放',
    description: '全球CDN加速节点覆盖，智能码率自适应技术，网络波动时自动切换画质，告别卡顿。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '纯净观影体验',
    description: '承诺影片全程无广告插入，极简界面零干扰，让你沉浸在纯粹的光影世界中。',
  },
  {
    id: 4,
    icon: 'ri-smartphone-line',
    title: '全设备无缝切换',
    description: '电脑、平板、手机全端自适应，观影进度实时同步，随时随地继续上次的精彩。',
  },
  {
    id: 5,
    icon: 'ri-database-2-line',
    title: '海量片库日更',
    description: '片库覆盖全球热门影视，每日动态更新。从经典老片到最新院线，好片看不停。',
  },
];

export const topics = [
  { id: 1, name: '科幻巨制', heat: '9.8万讨论', color: 'primary' as const },
  { id: 2, name: '暑期档', heat: '8.6万讨论', color: 'accent' as const },
  { id: 3, name: '经典港片', heat: '7.2万讨论', color: 'secondary' as const },
  { id: 4, name: '纪录片推荐', heat: '6.5万讨论', color: 'primary' as const },
  { id: 5, name: '华语新力量', heat: '5.8万讨论', color: 'accent' as const },
  { id: 6, name: '4K修复', heat: '5.3万讨论', color: 'secondary' as const },
  { id: 7, name: '动画电影', heat: '4.9万讨论', color: 'primary' as const },
  { id: 8, name: '悬疑烧脑', heat: '4.6万讨论', color: 'accent' as const },
  { id: 9, name: '文艺佳作', heat: '4.1万讨论', color: 'secondary' as const },
];

export const indexItems = [
  {
    id: 1,
    title: '按类型找片',
    count: '24个分类',
    description: '动作、喜剧、科幻、悬疑、动画、纪录等全覆盖',
    icon: 'ri-film-line',
  },
  {
    id: 2,
    title: '按年代索引',
    count: '横跨60年',
    description: '从1960年代经典到2026年最新力作',
    icon: 'ri-calendar-todo-line',
  },
  {
    id: 3,
    title: '导演合集',
    count: '200+位导演',
    description: '按导演作品时间线整理，系统了解风格演变',
    icon: 'ri-user-star-line',
  },
  {
    id: 4,
    title: '高分榜单',
    count: '实时更新',
    description: '综合评分、热度、讨论度多维排序推荐',
    icon: 'ri-medal-line',
  },
  {
    id: 5,
    title: '主题策划',
    count: '每周更新',
    description: '编辑精选专题，挖掘好片背后的故事与脉络',
    icon: 'ri-lightbulb-flash-line',
  },
  {
    id: 6,
    title: '新片速递',
    count: '每日追踪',
    description: '全球最新上映、即将上线的影视资讯一站掌握',
    icon: 'ri-rocket-line',
  },
  {
    id: 7,
    title: '随机发现',
    count: '惊喜推荐',
    description: '算法+编辑双重筛选，帮你发现意想不到的好片',
    icon: 'ri-shuffle-line',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '那些被遗忘的国产佳片',
    description: '十部评分极高却鲜为人知的国产电影，每一部都是被时光掩埋的明珠，值得重新发掘。',
    image: 'https://readdy.ai/api/search-image?query=nostalgic%20Chinese%20cinema%20aesthetic%20with%20warm%20vintage%20film%20texture%2C%20old%20movie%20projector%20atmosphere%2C%20golden%20amber%20lighting%2C%20soft%20grain%2C%20artistic%20composition%2C%20no%20people%20no%20text&width=600&height=400&seq=card-d01&orientation=landscape',
    tag: '冷门推荐',
    date: '2026-07-29',
  },
  {
    id: 2,
    title: '视觉盛宴：年度最佳摄影盘点',
    description: '从光影运用到色彩叙事，盘点今年最令人惊艳的电影摄影作品，每一帧都是壁纸。',
    image: 'https://readdy.ai/api/search-image?query=cinematography%20art%20with%20warm%20dramatic%20lighting%2C%20film%20camera%20lens%20aesthetic%2C%20golden%20bokeh%20effect%2C%20professional%20movie%20visual%20style%2C%20clean%20composition%2C%20no%20text&width=600&height=400&seq=card-d02&orientation=landscape',
    tag: '深度解析',
    date: '2026-07-27',
  },
  {
    id: 3,
    title: '女性导演的崛起之路',
    description: '越来越多的女性导演用独特视角讲述故事，她们的作品正在改变电影行业的叙事方式。',
    image: 'https://readdy.ai/api/search-image?query=artistic%20film%20director%20atmosphere%20with%20warm%20soft%20lighting%2C%20creative%20studio%20vibe%2C%20elegant%20composition%2C%20coral%20and%20cream%20tones%2C%20cinematic%20aesthetic%2C%20no%20people%20no%20text&width=600&height=400&seq=card-d03&orientation=landscape',
    tag: '行业观察',
    date: '2026-07-24',
  },
  {
    id: 4,
    title: '配乐的力量：电影音乐赏析',
    description: '好的配乐能让电影升华，盘点那些让人过耳不忘的经典电影原声和背后的创作故事。',
    image: 'https://readdy.ai/api/search-image?query=warm%20music%20studio%20atmosphere%20with%20soft%20amber%20lighting%2C%20vintage%20audio%20equipment%2C%20cinematic%20mood%2C%20golden%20and%20rose%20tones%2C%20artistic%20composition%2C%20no%20people%20no%20text&width=600&height=400&seq=card-d04&orientation=landscape',
    tag: '音乐赏析',
    date: '2026-07-21',
  },
  {
    id: 5,
    title: '从短片到大银幕的蜕变',
    description: '盘点五位从短片起家的导演，看他们如何用有限的资源拍出打动人心的作品，最终走向大银幕。',
    image: 'https://readdy.ai/api/search-image?query=independent%20film%20making%20atmosphere%20with%20warm%20natural%20light%2C%20simple%20movie%20set%2C%20golden%20hour%20glow%2C%20creative%20production%20vibe%2C%20clean%20composition%2C%20no%20people%20no%20text&width=600&height=400&seq=card-d05&orientation=landscape',
    tag: '创作故事',
    date: '2026-07-18',
  },
];